import { debounce } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';

import { GLOBAL_DEBOUNCE_DEBOUNCE_DELAY_IN_MS } from '~constants/consts';
import { useStores } from '~store/RootStore';

import { SearchInput } from './Filters/SearchInput';

export const DriverSearch = observer(() => {
  const [searchValue, setSearchValue] = useState('');

  const { driverSchedulerStore } = useStores();

  const applyDriversFilter = useRef(
    debounce(
      (search: string) => driverSchedulerStore.setAssigneesFilters({ search }),
      GLOBAL_DEBOUNCE_DEBOUNCE_DELAY_IN_MS,
    ),
  ).current;

  useEffect(() => {
    applyDriversFilter(searchValue);

    return () => {
      applyDriversFilter.cancel();
    };
  }, [searchValue]);

  return <SearchInput onChange={setSearchValue} value={searchValue} />;
});
